import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import UserTypeSelect from 'view/component/form-items/user-type-select'

const AttachmentUserTypeSelect = ({ userTypes }) => {
  return (
    <UserTypeSelect userTypes={userTypes} />
  )
}

AttachmentUserTypeSelect.propTypes = {
  userTypes: PropTypes.array
}

const mapStateToProps = ({ article }, { articleUuid }) => ({
  userTypes: (article.articles.results.find(({ uuid }) => uuid === articleUuid)).user_types
})

export default connect(mapStateToProps)(AttachmentUserTypeSelect)
